import {Expose} from 'class-transformer';

export class UserExtraFeeApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  price: number;

  @Expose()
  quantity: number;
}
